export default {
  metrics: {
    pickup: 'Ritiro',
    internal_delivery: 'Consegna interna',
    external_delivery: 'Consegna esterna',
  },
  events: {
    add_to_basket: 'Aggiungi articolo',
    begin_checkout: 'Vai al checkout',
    begin_purchase: 'Avvia pagamento',
    complete_purchase: 'Completa pagamento',
    order_placed: 'Completa pagamento',
    view_item: 'Visualizza articolo',
  },
};
